import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPropertyAmenity.ts
var t = () => e("propertyAmenity");
//#endregion
export { t as useTrPropertyAmenity };
